import React from 'react';

import {
    Form,
    Input,
    InputNumber,
    Button,
    Select,
    Checkbox,
    Switch
} from 'antd';

const { Option } = Select;

class StockIntegrationForm extends React.Component {

    render() {

        const plainOptions = [
            { value: 0, label: '12 AM'},
            { value: 1, label: '1 AM'},
            { value: 2, label: '2 AM'},
            { value: 3, label: '3 AM'},
            { value: 4, label: '4 AM'},
            { value: 5, label: '5 AM'},
            { value: 6, label: '6 AM'},
            { value: 7, label: '7 AM'},
            { value: 8, label: '8 AM'},
            { value: 9, label: '9 AM'},
            { value: 10, label: '10 AM'},
            { value: 11, label: '11 AM'},
            { value: 12, label: '12 PM'},
            { value: 13, label: '1 PM'},
            { value: 14, label: '2 PM'},
            { value: 15, label: '3 PM'},
            { value: 16, label: '4 PM'},
            { value: 17, label: '5 PM'},
            { value: 18, label: '6 PM'},
            { value: 19, label: '7 PM'},
            { value: 20, label: '8 PM'},
            { value: 21, label: '9 PM'},
            { value: 22, label: '10 PM'},
            { value: 23, label: '11 PM'},
        ]

        const { getFieldDecorator } = this.props.form;
        const { stockIntegration } = this.props;

        return (
            
            <Form
                name="basic"
                labelCol={{ span: 7 }}
                wrapperCol={{ span: 16 }}
                onSubmit={this.handleSubmit}
                style={{width: '60%'}}
                >
                    <Form.Item label="Supplier Id" style={{marginBottom: 4}}>
                        {getFieldDecorator('supplierId', {
                            initialValue: stockIntegration.supplierId,
                            rules: [{ required: true, message: 'Please input the supplierId!' }],
                        })(
                        <Input disabled={this.props.supplierId!='new'}/>
                        )}
                    </Form.Item>
                    <Form.Item label="Integration Type" style={{marginBottom: 4}}> 
                        {getFieldDecorator('integrationType', {
                            initialValue: stockIntegration.integrationType,
                            rules: [{ required: true, message: 'Please input the integrationType!' }],
                        })(
                        <Select>
                            <Option value="file">File</Option>
                            <Option value="api">API</Option>
                        </Select>
                        )}
                    </Form.Item>
                    <Form.Item label="Identifier Type" style={{marginBottom: 4}}> 
                        {getFieldDecorator('identifierType', {
                            initialValue: stockIntegration.identifierType,
                            rules: [{ required: true, message: 'Please input the identifierType!' }],
                        })(
                        <Select>
                            <Option value="_id">Product id</Option>
                            <Option value="model">Model</Option>
                            <Option value="sku">SKU</Option>
                        </Select>
                        )}
                    </Form.Item>
                    <Form.Item label="Identifier Column" style={{marginBottom: 4}}> 
                        {getFieldDecorator('identifierColumn', {
                            initialValue: stockIntegration.identifierColumn,
                            rules: [{ required: true, message: 'Please input the identifierColumn!' }],
                        })(
                        <InputNumber min={0}/>
                        )}
                    </Form.Item>
                    <Form.Item label="Quantity Column" style={{marginBottom: 4}}> 
                        {getFieldDecorator('quantityColumn', {
                            initialValue: stockIntegration.quantityColumn,
                            rules: [{ required: true, message: 'Please input the quantityColumn!' }],
                        })(
                        <InputNumber min={0}/>
                        )}
                    </Form.Item>
                    <Form.Item label="Timestamp Column" style={{marginBottom: 4}}> 
                        {getFieldDecorator('timestampColumn', {
                            initialValue: stockIntegration.timestampColumn,
                            rules: [{ required: true, message: 'Please input the timestampColumn!' }],
                        })(
                        <InputNumber min={0}/>
                        )}
                    </Form.Item>

                    <Form.Item label="Row Start" style={{marginBottom: 4}}> 
                        {getFieldDecorator('rowStart', {
                            initialValue: stockIntegration.rowStart,
                            rules: [{ required: true, message: 'Please input the rowStart!' }],
                        })(
                        <InputNumber min={0}/>
                        )}
                    </Form.Item>

                    <Form.Item label="Timestamp Format" style={{marginBottom: 4}}> 
                        {getFieldDecorator('timestampFormat', {
                            initialValue: stockIntegration.timestampFormat,
                            rules: [{ required: true, message: 'Please input the timestampFormat!' }],
                        })(
                        <Input/>
                        )}
                    </Form.Item>
                    <Form.Item label="Update Schedule" style={{marginBottom: 4}}> 
                        {getFieldDecorator('updateSchedule', {
                            initialValue: stockIntegration.updateSchedule,
                            rules: [{ required: true, message: 'Please input the updateSchedule!' }],
                        })(
                        <Checkbox.Group>
                            <div style={{display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gridAutoColumns: 'column'}}>
                                {plainOptions.map(option => <Checkbox value={option.value}>{option.label}</Checkbox>)}
                            </div>
                        </Checkbox.Group>
                        )}
                    </Form.Item>

                    <Form.Item label="File Endpoint" style={{marginBottom: 4}}> 
                        {getFieldDecorator('fileEndpoint', {
                            initialValue: stockIntegration.fileEndpoint,
                        })(
                            <Input />
                        )}
                    </Form.Item>

                    <Form.Item label="Incoming Email Address (, seperated)" style={{marginBottom: 4}}> 
                        {getFieldDecorator('incomingEmailAddresses', {
                            initialValue: stockIntegration.incomingEmailAddresses && stockIntegration.incomingEmailAddresses.reduce((acc,cur,index) => {
                                if (index==0) {
                                    return `${cur}`
                                }
                                return `${acc},${cur}`
                            },``),
                        })(
                            <Input />
                        )}
                    </Form.Item>

                    <Form.Item label="Do Not Notify Flag" style={{marginBottom: 4}}> 
                        {getFieldDecorator('doNotNotifyFlag', {
                            initialValue: stockIntegration.doNotNotifyFlag,
                        })(
                            <Switch />
                        )}
                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 20, span: 4 }}>
                        <Button type="primary" htmlType="submit">
                        Submit
                        </Button>
                    </Form.Item>

                </Form>
        )
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {

          if (!err) {
              this.props.onSubmit(values)
          }

        })
    };

}

export default Form.create()(StockIntegrationForm)


// WEBPACK FOOTER //
// ./src/components/stock-integration/form.js